/**
 * @generated SignedSource<<db3db42104cae14896677d8189b20101>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type noteTemplateGqlDeleteNoteTemplateMutation$variables = {
  id: string;
};
export type noteTemplateGqlDeleteNoteTemplateMutation$data = {
  readonly deleteNoteTemplate: {
    readonly deletedTemplateId: string;
    readonly ok: boolean | null;
  } | null;
};
export type noteTemplateGqlDeleteNoteTemplateMutation = {
  response: noteTemplateGqlDeleteNoteTemplateMutation$data;
  variables: noteTemplateGqlDeleteNoteTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "DeleteNoteTemplate",
    "kind": "LinkedField",
    "name": "deleteNoteTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedTemplateId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "noteTemplateGqlDeleteNoteTemplateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "noteTemplateGqlDeleteNoteTemplateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a5c87556024a6380795b3f3c2a0c0ea1",
    "id": null,
    "metadata": {},
    "name": "noteTemplateGqlDeleteNoteTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation noteTemplateGqlDeleteNoteTemplateMutation(\n  $id: ID!\n) {\n  deleteNoteTemplate(id: $id) {\n    ok\n    deletedTemplateId\n  }\n}\n"
  }
};
})();

(node as any).hash = "dbf7794b75c43c055eae5cf2bfabd1b1";

export default node;
